import { lazy } from "react";
import { RouteObject } from "react-router";

const LoginView = lazy(() => import("modules/login/login-view"));
const ProductEditView = lazy(
  () => import("modules/product-edit/product-edit-view"),
);
const ProductListView = lazy(
  () => import("modules/product-list/product-list-view"),
);
const ProductView = lazy(() => import("modules/product-view/product-view"));
const ProfileView = lazy(() => import("modules/profile/profile-view"));
const OrganizationGroupListView = lazy(
  () => import("modules/organization-group-list/organization-group-list-view"),
);
const OrganizationUnitListView = lazy(
  () => import("modules/organization-unit-list/organization-unit-list-view"),
);
const OrganizationUserListView = lazy(
  () => import("modules/organization-user-list/organization-user-list-view"),
);
const OrganizationUserAddView = lazy(
  () => import("modules/organization-user-add/organization-user-add-view"),
);
const NewProductView = lazy(
  () => import("modules/new-product/new-product-view"),
);
const AttributeListView = lazy(
  () => import("modules/attribute-list/attribute-list-view"),
);
const CollectorView = lazy(() => import("modules/collector/collector-view"));
const LogoutView = lazy(() => import("modules/logout/logout-view"));
const SysadminView = lazy(() => import("modules/sysadmin/sysadmin-view"));
const OrganizationEditView = lazy(
  () => import("modules/sysadmin/organization-edit-view"),
);
const PublicCollector = lazy(
  () => import("modules/collector/public-collector"),
);

export const privateRoutes: RouteObject[] = [
  {
    path: "/",
    element: <ProductListView />,
  },
  {
    path: "/products/:uuid",
    element: <ProductView />,
  },
  {
    path: "/products/:uuid/edit",
    element: <ProductEditView />,
  },
  {
    path: "/profile",
    element: <ProfileView />,
  },
  {
    path: "/groups",
    element: <OrganizationGroupListView />,
  },
  {
    path: "/units",
    element: <OrganizationUnitListView />,
  },
  {
    path: "/users",
    element: <OrganizationUserListView />,
  },
  {
    path: "/add-user",
    element: <OrganizationUserAddView />,
  },
  {
    path: "/new",
    element: <NewProductView />,
  },
  {
    path: "/attributes",
    element: <AttributeListView />,
  },
  {
    path: "/share",
    element: <CollectorView />,
  },
  { path: "/logout", element: <LogoutView /> },
  { path: "/sysadmin", element: <SysadminView /> },
  {
    path: "/organizations/:uuid/edit",
    element: <OrganizationEditView />,
  },
];

export const publicRoutes: RouteObject[] = [
  { path: "/login", element: <LoginView /> },
  { path: "/login/:token", element: <LoginView /> },
  { path: "/collector/:collectorLink", element: <PublicCollector /> },
];
